import { FC, useEffect, useState } from 'react';
import { Image } from "@fluentui/react-components";
import './OpenAiLogo.scss';

export interface OpenAiLogoProps {
    theme?: 'light'  | 'dark';
    size?: 'small' | 'medium';
}

// renders the default GPT (SyGPT) logo in different ways
export const OpenAiLogo: FC<OpenAiLogoProps> = (props: OpenAiLogoProps) => {
    const [height, setHeight] = useState(32);
    const [width, setWidth] = useState(50);

    useEffect(()=>{
        setHeight(props.size == 'small' ? 32 : 80);
        setWidth(props.size == 'small' ? 50 : 160);
    }, [props.size])

    return (
        <div 
            style={{ height, width }} 
            className="openai-logo-container"
        >
            <Image src={ props?.theme === 'light' ? '\SYGPT-Logo-Dark-BG.svg' : '\SYGPT-Logo-Color.svg'} height={height} width={width} fit='contain'></Image>
        </div>
    );
};
